import React from 'react'

import Collapsible from "react-collapsible";

import General from '../utils/General'

import LayoutEditor from "./LayoutEditor";
import Border from "./Border";
import Dropdown from "./Dropdown";
import ColorPicker from "./ColorPicker";
import { IconAndSVGPicker } from "./IconPickerGrid";

import Toggle from "./sectioninputs/Toggle";

import PortalModal from "./modal/PortalModal";
import DefaultData from "../utils/DefaultData";
import { updateIconType, updateIconValue } from './constants/utils';
import { productSettingsIds } from './constants/general';
import { RangeSlider } from './modal/PopupManagerModal';
import { getCleanedPixelValue, storefrontPopupDeviceTypesCollection } from './constants/storefrontPopupConstants';
import { SETTINGS_CONFIG } from './ProductDetailSettingsConfig';

export const DEFAULT_VISIBILITY = {
  desktop: true,
  mobile: true,
  mobilelarge: true,
  tablet: true,
  tabletlarge: true,
};
export const VISIBILITY_MAP = {
    breadCrumbsOptions: "breadCrumbsOptions", 
    productImage: "productImage",
    Price: "Price",
    Title: "Title",
    variants: "variants",
    customMessageOptions: "customMessageOptions",
    quantityAndButtonsOptions: "quantityAndButtonsOptions",
    productDescription: "productDescription",
    metaFields: "metaFields",
    subAndSave: "subAndSave",
    shareProduct: "shareProduct"
}
const settingOptions = Object.keys(SETTINGS_CONFIG).map(key => ({
  value: key,
  label: SETTINGS_CONFIG[key].label,
  id: SETTINGS_CONFIG[key].id
}));

export const visibilityStyles = {
  container: {
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.2s ease'
  },
  iconWrapper: (isVisible) => ({
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    opacity: isVisible ? 1 : 0.3,
    transition: 'all 0.2s ease'
  }),
  icon: (isVisible) => ({
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: isVisible ? '#2196F3' : '#757575',
    transition: 'color 0.2s ease'
  }),
  checkmark: {
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid white',
    animation: 'popIn 0.2s ease'
  }
};
export default class ProductDetailSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
      quickEditScroll: true,
      selectedSetting: this.props.openProductSettingsSection || "breadCrumbsOptions"
    }
    this.settingsRef = React.createRef();
  }

  _scrollSettinsInView() {
    if (this.settingsRef?.current && this.props.show && this.props.openProductSettingsSection) {
      this.settingsRef.current.scrollIntoView({
        behavior: 'smooth'
      })
      this.setState({
        quickEditScroll: false
      })
    }
  }

  _renderRefElement(openSection) {
    return this.state.quickEditScroll ? <div ref={openSection ? this.settingsRef : ""}></div> : null;
  }

  componentDidMount() {
    this._scrollSettinsInView()
  }

  componentDidUpdate() {
    this._scrollSettinsInView()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  handleLayoutUpdate = (layoutOrder) => {
    const {data} = this.state;
    if (!data) {
      return;
    }

    data.layoutOrder = layoutOrder;
    this.setState({layoutOrder}, () => {
      this.props.onUpdated(data);
      setTimeout(() => General.updateAll(), 300);
    });
  };

  _renderLayoutPreviewUI() {
    let { data } = this.state
    return (
      <LayoutEditor
        title={"Page Layout"}
        layout={data.layoutOrder || [...DefaultData.PRODUCT_PAGE_LAYOUT]}
        onChange={this.handleLayoutUpdate}
        defaultLayout={[...DefaultData.PRODUCT_PAGE_LAYOUT]}
        onReset={() => {
          this.setState({showResetLayoutModal: true});
        }}
        data={data}
        onUpdated={(data) => {
          this.setState({
            data
          }, () => this.props.onUpdated(data))
        }}
      />
    );
  }

  handleAutoPlayCarouselToggle = (checked) => {
    let { data } = this.state;
    data.autoplay_carousel_toggle = checked;
    const slider = window.flickityStore.mainSlider;
    if (!slider) return;

    checked ? slider.playPlayer() : slider.stopPlayer();
    this.props.onUpdated(data);
  };

  handleStickyLeftColumnToggle = (checked) => {
    const { data } = this.state;
    data.sticky_left_column = checked;
    this.setState({ data }, () => {
      this.props.onUpdated(data);
    });
  };

  handleSliderPositionChange = (option) => {
    const { data } = this.state;
    data.slider_position = option.value;
    this.setState({ data }, () => {
      this.props.onUpdated(data);
      setTimeout(() => {
        General.updateAll();
        window.dispatchEvent(new Event('resize'));
      }, 0);
    });
  };

  _displaySettings() {
    let { data } = this.state
    let WIDTHOPTIONS = [
      {
        value: "standard",
        label: "Standard"
      },
      {
        value: "even",
        label: "Even"
      }
    ]
    return (
      <>
        <Border>
          <Collapsible
            trigger={"Display"}
          >
            <br/>
            <span>Column Width</span>
            <Dropdown
              options={WIDTHOPTIONS}
              value={WIDTHOPTIONS.find(
                (mode) => mode.value === (data.column_width || "standard")
              )}
              onChange={option => {
                data.column_width = option.value
                this.props.onUpdated(data)
              }}
              placeholder="Select An Option"
            />
            <br/>
            <Toggle
              id="stickyLeftColumnToggle"
              title="Sticky Left Column"
              checked={data?.sticky_left_column}
              onChange={this.handleStickyLeftColumnToggle}
            />
            <ColorPicker
              title="Background Color"
              color={data?.container_bg_color || ""}
              onColorSelected={(color) => {
                data.container_bg_color = color;
                this.props.onUpdated(data);
              }}
            />
          </Collapsible>
        </Border>
      </>
    )
  }
  _ensureComponentVisibility() {
    const  {data, selectedSetting } = this.state;
    const nextData = {...data};
    nextData.visibility = nextData.visibility || {};
    const visibilityKey = VISIBILITY_MAP[selectedSetting];
    if (visibilityKey) {
      nextData.visibility[visibilityKey] = {
        ...DEFAULT_VISIBILITY,
        ...(nextData.visibility[visibilityKey] || {})
      }
    }
    return nextData;
  }
  _updateComponentVisibility (device, checked) {
    const { selectedSetting } = this.state;
    const visibilityKey = VISIBILITY_MAP[selectedSetting];
    if (!visibilityKey) return;
    const  nextData = this._ensureComponentVisibility();
    nextData.visibility[visibilityKey]= {
      ...nextData.visibility[visibilityKey],
      [device] : !!checked
    }
    this.setState({ data: nextData }, () => {
      this.props.onUpdated(nextData);
      setTimeout(() => {
        General.updateAll();
        try {
          window.dispatchEvent(new Event('resize'));
        } catch (e) {}
      }, 0);
    })
  }
  _ensureDetailVisibility(detailCount = 9) {
    const { data } = this.state;
    const nextData = { ...data };

    nextData.visibility = nextData.visibility || {};
    nextData.visibility.detail = Array.isArray(nextData.visibility.detail)
      ? [...nextData.visibility.detail]
      : [];

    for (let i = 0; i < detailCount; i++) {
      nextData.visibility.detail[i] = {
        ...DEFAULT_VISIBILITY,
        ...(nextData.visibility.detail[i] || {}),
      };
    }

    return nextData;
  }
  _handleDetailSelect = (opt) => {
    const idx =
      typeof opt?.value === 'string' && opt.value.startsWith('detail-')
        ? Math.max(0, parseInt(opt.value.replace('detail-', ''), 10) - 1)
        : 0;

    const nextData = this._ensureDetailVisibility();
    this.setState({ data: nextData, selectedDetailIndex: idx });
  };
  _updateDetailVisibility = (device, checked) => {
    const { selectedDetailIndex = null } = this.state;
    const defaultIndex = this.props.defaultIndex ? this.props.defaultIndex - 1 : 0;
    const selected = selectedDetailIndex || selectedDetailIndex === 0 ? selectedDetailIndex : defaultIndex;
    const nextData = this._ensureDetailVisibility();

    nextData.visibility.detail[selected] = {
      ...nextData.visibility.detail[selected],
      [device]: !!checked,
    };

    this.setState({ data: nextData }, () => {
      this.props.onUpdated(nextData);

      setTimeout(() => {
        General.updateAll();
        try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      }, 0);
    });
  };
  _renderToggles(field) {
    const { data, selectedDetailIndex = null, selectedSetting } = this.state;

    const isDetailVisibility = selectedSetting === "detail";
    let visibility;
    if (isDetailVisibility) {
      const defaultIndex = this.props.defaultIndex ? this.props.defaultIndex - 1 : 0;
      const selected = selectedDetailIndex || selectedDetailIndex === 0 ? selectedDetailIndex : defaultIndex;
      const details = data?.visibility?.detail || [];
      visibility = {
        ...DEFAULT_VISIBILITY,
        ...(details[selected] || {}),
      };
    } else {
      const visibilityKey = VISIBILITY_MAP[selectedSetting];
      visibility = {
        ...DEFAULT_VISIBILITY,
        ...(data?.visibility?.[visibilityKey] || {})
      }
    }
    const handleToggle = isDetailVisibility ? this._updateDetailVisibility : this._updateComponentVisibility.bind(this);
    return (
      <>
        <span className="d-block mb-2">{field.label}</span>
        <div className='d-flex justify-content-around mt-3'>
          {storefrontPopupDeviceTypesCollection.map((item, idx) => {
            const isVisible = visibility[item.device];
            return (
              <div
                key={idx}
                className="storefront-popup-settings-toggle"
                style={visibilityStyles.container}
                onClick={() => handleToggle(item.device, !isVisible)}
                title={`${item.deviceName}: ${isVisible ? 'Visible' : 'Hidden'}`}
              >
                <div style={visibilityStyles.iconWrapper(isVisible)}>
                  <div 
                    style={visibilityStyles.icon(isVisible)}
                    dangerouslySetInnerHTML={{ __html: item.svg }}
                  />
                  {isVisible && (
                    <div style={visibilityStyles.checkmark}>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="white">
                        <path d="M2 5 L4 7 L8 3" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
        <br/>
      </>
    );
  }
  _renderDetailSettings() {
    const { selectedDetailIndex = null } = this.state;

    const defaultIndex = this.props.defaultIndex ? this.props.defaultIndex - 1 : 0;
    const selected = selectedDetailIndex || selectedDetailIndex === 0 ? selectedDetailIndex : defaultIndex;

    const DETAIL_OPTIONS = Array.from({ length: 9 }).map((_, i) => ({
      value: `detail-${i + 1}`,
      label: `Detail ${i + 1}`,
    }));

    const currentOption = DETAIL_OPTIONS[selected];

    return (
      <>
        <Dropdown
          options={DETAIL_OPTIONS}
          value={currentOption}
          placeholder="Select An Option"
          onChange={this._handleDetailSelect}
        />
      </>
    );
  }
  

  renderSelectedSettings = () => {
    const config = SETTINGS_CONFIG[this.state.selectedSetting];
    
    if (!config) return null;

    return (
      <>
        <br />
        {config.fields.map((field, index) => this.renderField(field, index))}
      </>
    );
  };
  renderField = (field, index) => {
    switch (field.type) {
      case 'dropdown':
        return this.renderDropdown(field, index);
      
      case 'colorPicker':
        return this.renderColorPicker(field, index);
      
      case 'rangeSlider':
        return this.renderRangeSlider(field, index);
      
      case 'toggle':
        return this.renderToggle(field, index);
      
      case 'section':
        return this.renderSection(field, index);
      
      case 'textInput':
        return this.renderTextInput(field, index);
      
      case 'iconPicker':
        return this.renderIconPicker(field, field.key);
      
      case 'conditional':
        return this.renderConditional(field, index);
      
      case 'conditionalColorPicker':
        return this.renderConditionalColorPicker(field, index);

      case 'variantStyleDropdown':
        return this.renderVariantStyleDropdown(field, index);

      case 'detailSelector':
        return this._renderDetailSettings(field, index);

      case 'visibilityToggles':
        return this._renderToggles(field, index);
      
      default:
        return null;
    }
  };
  _generateStyleSettings() {
    return (
      <Border>
        <Collapsible trigger="Style Settings" open={true}>
          <br/>
          <div className="dynamic-product-settings">
            <div className="mb-4">
              <Dropdown
                options={settingOptions}
                value={settingOptions.find(opt => opt.id === this.state.selectedSetting)}
                onChange={(option) => this.setState({ selectedSetting: option.id })}
                placeholder="Select a setting to configure"
              />
            </div>
            
            <div className="settings-content mt-4">
              {this.renderSelectedSettings()}
            </div>
          </div>
        </Collapsible>
      </Border>
    );
  }
  getCurrentData = () => {
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    return isSubscribeAndSave ? this.props.subscribeAndSaveSettings : this.state.data;
  };

  renderDropdown = (field, index) => {
    const currentData = this.getCurrentData();
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    return (<div key={index} className="mb-3">
      <span className="d-block mb-2">{field.label}</span>
      <Dropdown
        options={field.options}
        value={field.options.find(opt => opt.value === currentData[field.key])}
        onChange={(option) => {
          if (isSubscribeAndSave) {
            this.props.updateSubscribeAndSaveSettings({ [field.key]: option.value });
          } else {
            const { data } = this.state;
            data[field.key] = option.value;
            this.props.onUpdated(data);
          }
          // Handle custom handler if exists
          if (field.customHandler === 'handleSliderPositionChange') {
            this.handleSliderPositionChange(option);
          }
        }}
        placeholder="Select An Option"
      />
    </div>)
  };
  renderColorPicker = (field, index) => {
    const currentData = this.getCurrentData();
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    return (
      <div key={index} className="mb-3">
        <ColorPicker
          title={field.title}
          color={currentData[field.key] || ''}
          onColorSelected={(color) => {
            if (isSubscribeAndSave) {
              this.props.updateSubscribeAndSaveSettings(field.key, color);
            } else {
              const { data } = this.state;
              data[field.key] = color;
              this.props.onUpdated(data);
            }
          }}
        />
      </div>
    );
  };

  renderRangeSlider = (field, index) => {
    const currentData = this.getCurrentData();
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    return (<div key={index}>
      <RangeSlider
        label={field.label}
        min={field.min}
        max={field.max}
        step={field.step}
        value={getCleanedPixelValue(currentData[field.key]) || 0}
        onChange={(propertyName, value) => {
          if (isSubscribeAndSave) {
              this.props.updateSubscribeAndSaveSettings(field.key, `${value}px`);
            } else {
              const { data } = this.state;
              data[field.key] = `${value}px`;
              this.props.onUpdated(data);
            }
        }}
        propertyName={field.key}
        labelClassName="storefront-popup-settings-sub-heading"
      />
    </div>)
  };
  renderToggle = (field, index) => {
    const currentData = this.getCurrentData();
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    return (<div key={index} className="mb-3">
      <Toggle
        id={field.id}
        title={field.title}
        checked={currentData[field.key] || false}
        tooltip={field.tooltip}
        onChange={(checked) => {
          if (isSubscribeAndSave) {
            // Special handling for Subscribe & Save icon toggle
            if (field.key === 'useCustomIcon' && !checked) {
              this.props.updateSubscribeAndSaveSettings({
                oneTimeIcon: '',
                subscribeIcon: '',
                useCustomIcon: false
              });
            } else {
              this.props.updateSubscribeAndSaveSettings(field.key, checked);
            }
          } else {
            const { data } = this.state;
            data[field.key] = checked;
            this.props.onUpdated(data);
            
            // Handle custom toggle handlers
            if (field.customHandler === 'handleAutoPlayCarouselToggle') {
              this.handleAutoPlayCarouselToggle(checked);
            }
          }
        }}
      />
    </div>
  )};

  renderSection = (field, index) => {
    let { data } = this.state;
    return (<div key={index} className="mb-3">
      <h5 className="font-weight-bold mb-0">{field.title}</h5>
      <hr className='m-0'/>
    </div>
  )};

  renderTextInput = (field, index) => {
    let { data } = this.state;
    return (<div key={index} className="mb-3">
      <label className="d-block mb-2">{field.label}</label>
      <input
        type="text"
        className="form-control"
        value={data[field.key] || field.defaultValue || ''}
        onChange={(e) => {
          data[field.key] = e.target.value;
          this.props.onUpdated(data);
        }}
      />
    </div>
  )};

  renderIconPicker = (field, iconKey) =>{
     const currentData = this.getCurrentData();
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    const iconValue = currentData[iconKey];
    const isAccordion = field.accordion || false;
    const iconPickerContent = (
      <IconAndSVGPicker
        label="Current Icon"
        displayIconFontSize={30}
        displayIconClassName=""
        currentIcon={iconValue}
        iconPickerColumnWidth={110}
        iconPickerClassName={isSubscribeAndSave ? "subscribe-icon-grp" : ""}
        iconPickerWidth={isSubscribeAndSave ? 356 : 335}
        iconPickerRowHeight={110}
        onSelected={(actionType, actionValue) => {
          let updatedIcon;
          
          if (actionType === "svg") {
            updatedIcon = updateIconValue(actionType, iconValue, actionValue);
          } else if (actionType === "type") {
            updatedIcon = updateIconType(iconValue, actionValue);
          } else {
            let tempIcon = actionValue.icon?.startsWith("fa-")
              ? actionValue.icon
              : `icon icon--lg icon-${actionValue.name}`;
            updatedIcon = updateIconValue(actionType, iconValue, tempIcon);
          }
          
          if (isSubscribeAndSave) {
            this.props.updateSubscribeAndSaveSettings({ [field.key]: updatedIcon });
          } else {
            const { data } = this.state;
            data[field.key] = updatedIcon;
            this.props.onUpdated(data);
          }
        }}
      />
    );
     if (isAccordion) {
      return (
        <div key={iconKey} className="mb-3">
          <Collapsible trigger={field.label}>
            <br />
            {iconPickerContent}
          </Collapsible>
        </div>
      );
    }

    // Render as regular icon picker
    return (
      <div key={iconKey} className="mb-3">
        <span className="d-block mb-2">{field.label}</span>
        {iconPickerContent}
      </div>
    );
  };

  renderConditional = (field, index) => {
    const currentData = this.getCurrentData();
    const isSubscribeAndSave = this.state.selectedSetting === 'subAndSave';
    const shouldRender = field.condition(currentData);
    
    if (!shouldRender) return null;

    // Special handling for Subscribe & Save icon pickers with tabs
    if (isSubscribeAndSave && field.fields[0]?.type === 'iconPicker') {
      const { subscribeAndSaveSettings } = this.props;
      return (
        <div key={index} className="tabs-container tabs--folder">
          <ul className="tabs subscribe-icon">
            {[
              { key: 'oneTime', label: 'One Time' },
              { key: 'subscribe', label: 'Subscribe & Save' },
            ].map(tab => (
              <li
                key={tab.key}
                className={subscribeAndSaveSettings.activeIconTab === tab.key ? 'active' : ''}
                onClick={() => this.props.updateSubscribeAndSaveSettings('activeIconTab', tab.key)}
              >
                <div className="tab__title">
                  <span>{tab.label}</span>
                </div>
              </li>
            ))}
          </ul>

          <ul className="tabs-content">
            {['oneTime', 'subscribe'].map(tabKey => (
              <li
                key={tabKey}
                className={subscribeAndSaveSettings.activeIconTab === tabKey ? 'active' : ''}
              >
                <div className="tab__content">
                  {field.fields
                    .filter(f => f.key === `${tabKey}Icon`)
                    .map((subField, subIndex) => 
                      this.renderField(subField, `${index}-${subIndex}`)
                    )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    }
    return (
      <div key={index}>
        {field.fields.map((subField, subIndex) => 
          this.renderField(subField, `${index}-${subIndex}`)
        )}
      </div>
    );
  };

  renderConditionalColorPicker = (field, index) => {
    let { data } = this.state;
    const shouldRender = field.condition(data);
    
    if (!shouldRender) return null;
    
    return this.renderColorPicker(field, index);
  };
 renderVariantStyleDropdown = (field, index) => {
    const { data } = this.state;
    const variantNumber = field.variantNumber;
    const currentKey = field.key;
    
    // Find which variant is currently using img_tile
    let imgTileVariantType = "";
    [1, 2, 3].forEach((num) => {
      const key = `variant${num}_style`;
      if (data[key] === "img_tile") {
        imgTileVariantType = key;
      }
    });

    // Base options without Image Tile
    let OPTIONS = [
      { value: "dropdown", label: "Dropdown Menu" },
      { value: "btn_horizontal", label: "Button Horizontal" },
      { value: "btn_vertical", label: "Button Vertical" }
    ];

    // Only add Image Tile option if:
    // 1. This variant is already using it, OR
    // 2. No other variant is using it
    const isCurrentlyImageTile = imgTileVariantType === currentKey;
    if (isCurrentlyImageTile || !imgTileVariantType) {
      OPTIONS.push({ value: "img_tile", label: "Image Tile" });
    }

    return (
      <div key={index}>
        <br/>
        <div className="mb-3">
          <span className="d-block mb-2">{field.label}</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(opt => opt.value === data[currentKey])}
            onChange={(option) => {
              data[currentKey] = option.value;
              this.props.onUpdated(data);
            }}
            placeholder="Select An Option"
          />
        </div>
        
        {/* Show Image Tile sub-options if this variant is using img_tile */}
        {isCurrentlyImageTile && this.renderImageTileOptions(variantNumber)}
      </div>
    );
  };
  renderImageTileOptions = (variantNumber) => {
    const { data } = this.state;
    
    const POSITION_OPTIONS = [
      { value: "left", label: "Left" },
      { value: "right", label: "Right" },
      { value: "top", label: "Top" },
      { value: "img-only", label: "Image Only" }
    ];

    const ASPECT_RATIO_OPTIONS = [
      { value: "", label: "Default" },
      { value: "img-tile-ratio img-tile-ratio-1x1", label: "1x1" },
      { value: "img-tile-ratio img-tile-ratio-4x3", label: "4x3" },
      { value: "img-tile-ratio img-tile-ratio-16x9", label: "16x9" },
      { value: "img-tile-ratio img-tile-ratio-21x9", label: "21x9" }
    ];

    return (
      <>
        <div className="mb-3">
          <span className="d-block mb-2">Variant {variantNumber} Image Position</span>
          <Dropdown
            options={POSITION_OPTIONS}
            value={POSITION_OPTIONS.find(
              opt => opt.value === (data.img_tile_position || "right")
            )}
            onChange={(option) => {
              data.img_tile_position = option.value;
              this.props.onUpdated(data);
            }}
            placeholder="Select An Option"
          />
        </div>

        {/* Only show Aspect Ratio if Image Only is selected */}
        {data.img_tile_position === "img-only" && (
          <div className="mb-3">
            <span className="d-block mb-2">Variant {variantNumber} Aspect Ratio</span>
            <Dropdown
              options={ASPECT_RATIO_OPTIONS}
              value={ASPECT_RATIO_OPTIONS.find(
                opt => opt.value === (data.img_only_aspect_ratio || "")
              )}
              onChange={(option) => {
                data.img_only_aspect_ratio = option.value;
                this.props.onUpdated(data);
              }}
              placeholder="Select An Option"
            />
          </div>
        )}
      </>
    );
  };

  _renderResetLayoutModal() {
    return (
      <PortalModal
        show={this.state.showResetLayoutModal}
        showAsSideMenu="false"
        onHide={() => this.setState({showResetLayoutModal: false})}
      >
        <div className="modal-share">
          <div className="modal-head">
            <h2 className="mb-0">Reset Layout</h2>
          </div>

          <div className="row modal-body">
            <div className="col-md-12">
              <h4>Are you sure you want to reset the layout to its default configuration?</h4>
            </div>
          </div>

          <div className="text-right modal-footer">
            <a
              className="btn type--uppercase"
              onClick={() => this.setState({showResetLayoutModal: false})}
            >
            <span className="btn__text">
              Cancel
            </span>
            </a>
            <a
              className="btn btn--primary type--uppercase"
              style={{
                background: "#fa6160",
                borderColor: "#fa6160"
              }}
              onClick={() => {
                this.setState({showResetLayoutModal: false});
                this.handleLayoutUpdate(this.defaultLayout);
              }}
            >
            <span className="btn__text">
              Reset Layout
            </span>
            </a>
          </div>
        </div>
      </PortalModal>
    );
  }

  




  render(){
    
    return (
      <>
        {this._renderLayoutPreviewUI()}

        {this._displaySettings()}

        {this._generateStyleSettings()}

        {this._renderResetLayoutModal()}

        {this._renderRefElement(this.props.openProductSettingsSection === productSettingsIds.htmlBlock)}
      </>
    )
  }
}
